import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Burakyol-logo.jpeg";
import aski from "./assets/aski-logo.png";
import cevre from "./assets/çevrelogo.png";
import dsi from "./assets/dsi-logo.png";
import ica from "./assets/ica-logo.png";
import iga from "./assets/iga-logo.svg.png";
import ilbank from "./assets/ilbank-logo.png";
import kgm from "./assets/kgm_logo.png";
import toki from "./assets/toki-logo.jpg";
import emlak from "./assets/emlak-logo.png";

const heroSlides = [
    {
        src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2340",
        alt: "Kentsel Dönüşüm",
        title: "Kentsel Dönüşüm Projeleri",
        subtitle: "Şehirlerin dönüşümünde öncü rol oynayarak, modern ve güvenli yaşam alanları oluşturuyoruz",
    },
    {
        src: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2340",
        alt: "Altyapı Çalışması",
        title: "Sürdürülebilir Altyapı Projeleri",
        subtitle: "Çevre dostu yaklaşımımızla, yarının yaşam alanlarını bugünden tasarlıyoruz",
    },
    {
        src: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2340",
        alt: "Modern Yapı",
        title: "Üstyapı ve Konut Projeleri",
        subtitle: "Kaliteli malzeme ve usta işçilikle, geleceğin yaşam alanlarını inşa ediyoruz",
    },
];

const coreValues = [
    {
        title: "İş Sağlığı ve Güvenliği",
        text: "Şantiyelerimizde sıfır kaza prensibiyle çalışıyor, tüm ekibimizin güvenliğini en üst düzeyde sağlıyoruz.",
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        ),
    },
    {
        title: "İnovatif Mühendislik",
        text: "Geleneksel yöntemleri modern teknolojilerle harmanlayarak, projelerimize zaman ve maliyet verimliliği katıyoruz.",
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        ),
    },
    {
        title: "Zamanında Teslimat",
        text: "Güçlü tedarik ağımız ve uzman ekibimiz sayesinde projeleri taahhüt ettiğimiz sürede eksiksiz teslim ediyoruz.",
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        ),
    },
    {
        title: "Üst Düzey Kalite",
        text: "ISO standartlarında malzeme seçimi ve detaylı işçilikle yapıların ömrünü maksimize ediyoruz.",
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        ),
    },
];

const approachSteps = [
    {
        title: "Etüd & Planlama",
        description: "Projenin çevresel etkilerini ve zemin etüdünü analiz ederek, en verimli ve sürdürülebilir mimari/mühendislik planını oluşturuyoruz.",
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        ),
    },
    {
        title: "Uygulama",
        description: "Onaylanan projeyi sahadaki uzman ekibimizle hayata geçiriyor; kalite kontrol ve iş güvenliği standartlarını her aşamada koruyoruz.",
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        ),
    },
    {
        title: "Teslimat",
        description: "Projeyi taahhüt edilen sürede, eksiksiz ve anahtar teslim olarak teslim ediyor; teslim sonrası destek süreçlerini yönetiyoruz.",
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        ),
    },
];

const featuredProjects = [
    {
        img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBSO7q5jBNOT3hqLKDm3SBl2gq1FNkbf3A6w7XGvW-FczLOWzsAngi8ITvcu3ZVz8p1PlS2O8BLLcKUcYY3CKY63FLoeynerMHqQUW1679c6oPyUe-ZT7m5zc5uDN9f-3BQLDY9Z7b73BTUzr4SmYNxUrw3XFXzKSbTz-_6dpzkjmI40NML8wW37GAhFhQKr6JYxr2EPsuNY8KoBwVPVrs0HJaDY6amCLg5iO1GmiVcZvL41NWY2Bn0LZNm-lk3Yt6Vk0N6SGuriNbj",
        alt: "Konut Projesi",
        tag: "Tamamlandı",
        category: "Üstyapı",
        title: "Modern Yaşam Konutları",
        featured: true,
    },
    {
        img: "https://lh3.googleusercontent.com/aida-public/AB6AXuCpG6adVPxKZeeK9eJ2dK9tUanRlhk8_krZDoEDsafUQ9gt2Yyc3YsfqK4_I23s6a-cqJRRE4Y6kyCMgihqtNrrwvRDs2u9N5xn3Vmo77U2yYOslnbl8oALfBx2hQnDRcw2t-epqcBs21ooh_k46gNLaJs7-fK4J6qNNMW5ScFLhb5EL12iPGYhQEirD7se3PkbCfglYnhMqf-zCubvEnv_dINqdjLPj_S13Fr0HeMXaxhn9AqfDqqdGC7Bl-2OYqfwfbyoyRGodLCY",
        alt: "Altyapı Projesi",
        tag: "Devam Ediyor",
        category: "Altyapı Projesi",
        title: "Kent İçi Dönüşüm Projesi",
        featured: false,
    },
    {
        img: "https://lh3.googleusercontent.com/aida-public/AB6AXuDJaqzd1zJdXX1EdZhbTwql0mVIvsGXueArpb4dyIw4esyXpBY8wHK5JFAojAFJUPAIhbjpuOoYEDNE8l605KW6euYmMCfS48bPI1HvdevuWn7Nz8VwfPIiJOMHuDVxrM6Y3W-iETid73M2yg3TIIPdazulPFgqx1UguSzfxU_s4S-q4mEvXX9AZ4hWtDx_vyn_dBZnS5o9AAuLJYnkmY-AjcFw3apWVyaF23rST8wE9U0w261HX2sRI4MBqiquoRVKZrNvFj0BbpTe",
        alt: "Ticari Proje",
        tag: "Planlama",
        category: "Ticari Yapı",
        title: "Vadi Plaza Kompleksi",
        featured: false,
    },
];

function Home() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [mounted, setMounted] = useState(false);

    // Minimum swipe distance (in px)
    const minSwipeDistance = 50;

    const goToSlide = useCallback((index) => {
        setCurrentSlide(index);
    }, []);

    const nextSlide = useCallback(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, []);

    const prevSlide = useCallback(() => {
        setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
    }, []);

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        
        if (isLeftSwipe) {
            nextSlide();
        }
        if (isRightSwipe) {
            prevSlide();
        }
    };

    useEffect(() => {
        // Trigger initial animation
        setMounted(true);
    }, []);

    useEffect(() => {
        const timer = setInterval(nextSlide, 5000);
        return () => clearInterval(timer);
    }, [nextSlide]);

    return (
        <div className="relative text-text font-body-lg min-h-screen antialiased selection:bg-black selection:text-white bg-white">

            {/* Logo - Navbarın Dışında Sol Tarafta (Large Screens) */}
            <div className="hidden xl:block absolute left-[15vw] 2xl:left-[22vw] 3xl:left-[28rem] top-[60px] -translate-y-1/2 z-40 pointer-events-auto w-[80px] h-[80px] 2xl:w-[90px] 2xl:h-[90px] 3xl:w-[100px] 3xl:h-[100px] rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-xl">
                <img
                    src={logo}
                    alt="Logo"
                    className="w-full h-full object-cover"
                />
            </div>
        
            {/* ========== 1. Floating Nav (TopAppBar) ========== */}
            <header className="fixed top-[12px] md:top-[24px] left-0 right-0 z-50 flex items-center justify-center px-4 md:px-sm w-full pointer-events-none">
                {/* Navbar Capsule */}
                <div className="pointer-events-auto w-full max-w-[700px] h-[60px] md:h-[72px] flex items-center justify-between bg-[#01346b] backdrop-blur-xl rounded-full px-4 md:px-xs py-xs shadow-xl border border-white/10">
                    <div className="flex items-center gap-4 pl-2 md:pl-xs">
                        {/* Mobile Logo */}
                        <div className="md:hidden w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                            <img src={logo} alt="Logo" className="w-full h-full object-cover" />
                        </div>
                        
                        {/* Desktop Menu */}
                        <nav className="hidden md:flex items-center gap-6 pl-4">
                            <Link to="/hakkimizda" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hakkımızda</Link>
                            <Link to="/projeler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Projeler</Link>
                            <Link to="/hizmetler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hizmetler</Link>
                            <Link to="/iletisim" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">İletişim</Link>
                        </nav>
                        
                        {/* Mobile Hamburger */}
                        <button 
                            className="md:hidden text-white p-14 "
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            {mobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                    <Link to="/" className="bg-page-bg text-black font-label text-sm md:text-label h-full px-4 md:px-8 rounded-full hover:bg-white transition-colors duration-300 scale-95 hover:scale-100 shrink-0 flex items-center shadow-sm">
                        Anasayfa
                    </Link>
                </div>

                {/* Mobile Menu Dropdown */}
                <div 
                    className={`md:hidden absolute top-[72px] left-4 right-4 bg-[#01346b] backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 overflow-hidden pointer-events-auto transition-all duration-500 ease-out ${
                        mobileMenuOpen 
                            ? 'opacity-100 translate-y-0 max-h-96' 
                            : 'opacity-0 -translate-y-4 max-h-0 pointer-events-none'
                    }`}
                >
                    <nav className="flex flex-col p-4">
                        <Link to="/hakkimizda" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hakkımızda</Link>
                        <Link to="/projeler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Projeler</Link>
                        <Link to="/hizmetler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hizmetler</Link>
                        <Link to="/iletisim" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>İletişim</Link>
                    </nav>
                </div>
            </header>

            <main>
                {/* ========== 1. Carousel / Hero ========== */}
                <section className="min-h-[80vh] md:min-h-screen flex items-center justify-center bg-white pt-[20px] md:pt-[96px] pb-[20px] md:pb-[60px]">
                    <div className="max-w-[1728px] mx-auto px-4 md:px-margin w-full">
                    <div 
                        className="w-full max-w-[1492px] mx-auto bg-panel-bg overflow-hidden shadow-2xl relative z-10 rounded-[20px] md:rounded-[32px] h-[60vh] md:h-[75vh] lg:h-[80vh] touch-pan-y"
                        onTouchStart={onTouchStart}
                        onTouchMove={onTouchMove}
                        onTouchEnd={onTouchEnd}
                    >
                        {/* Carousel Slides with Ken Burns Effect */}
                        {heroSlides.map((slide, index) => (
                            <div
                                key={index}
                                className="absolute inset-0 transition-all duration-[1500ms] ease-in-out"
                                style={{ 
                                    opacity: (mounted && currentSlide === index) ? 1 : 0, 
                                    zIndex: currentSlide === index ? 1 : 0,
                                }}
                            >
                                <img
                                    alt={slide.alt}
                                    className={`w-full h-full object-cover transition-transform duration-[8000ms] ${
                                        mounted && currentSlide === index ? 'scale-110' : 'scale-100'
                                    }`}
                                    src={slide.src}
                                />
                            </div>
                        ))}
                        
                        {/* Gradient overlay - Enhanced for better text readability */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20 z-10 pointer-events-none"></div>

                        {/* Text Overlay - Content for each slide */}
                        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center px-4 sm:px-6 md:px-12 text-center pointer-events-none">
                            {heroSlides.map((slide, index) => (
                                <div
                                    key={index}
                                    className="absolute inset-0 flex flex-col items-center justify-center transition-all duration-[1200ms] ease-out"
                                    style={{
                                        opacity: (mounted && currentSlide === index) ? 1 : 0,
                                        transform: (mounted && currentSlide === index)
                                            ? 'translateY(0) scale(1)' 
                                            : 'translateY(30px) scale(0.9)',
                                        transitionDelay: (mounted && currentSlide === index) ? '200ms' : '0ms',
                                    }}
                                >
                                    <div className="max-w-5xl w-full">
                                        <h1 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-3 sm:mb-4 md:mb-6 leading-tight px-4">
                                            {slide.title}
                                        </h1>
                                        <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed px-4 mb-6 sm:mb-8 md:mb-10">
                                            {slide.subtitle}
                                        </p>
                                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center pointer-events-auto px-4">
                                            <Link
                                                to="/projeler"
                                                className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-white text-[#01346b] font-semibold rounded-full hover:bg-white/90 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 text-center text-sm sm:text-base"
                                            >
                                                Projelerimizi İncele
                                            </Link>
                                            <Link
                                                to="/iletisim"
                                                className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-white/10 backdrop-blur-md text-white font-semibold rounded-full border-2 border-white/30 hover:bg-white/20 transition-all duration-300 hover:scale-105 text-center text-sm sm:text-base"
                                            >
                                                İletişime Geç
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Navigation Arrows - Hidden on small mobile */}
                        <button
                            onClick={() => goToSlide((currentSlide - 1 + heroSlides.length) % heroSlides.length)}
                            className="hidden sm:flex absolute left-3 sm:left-4 md:left-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 items-center justify-center text-white hover:bg-white/20 transition-all duration-300 group"
                            aria-label="Previous slide"
                        >
                            <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <button
                            onClick={() => goToSlide((currentSlide + 1) % heroSlides.length)}
                            className="hidden sm:flex absolute right-3 sm:right-4 md:right-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 items-center justify-center text-white hover:bg-white/20 transition-all duration-300 group"
                            aria-label="Next slide"
                        >
                            <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </button>

                        {/* Dot Indicators - Responsive */}
                        <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2 sm:gap-3">
                            {heroSlides.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToSlide(index)}
                                    className={`transition-all duration-500 rounded-full ${currentSlide === index
                                        ? "w-6 sm:w-8 h-2 sm:h-3 bg-white shadow-[0_0_12px_rgba(255,255,255,0.5)]"
                                        : "w-2 sm:w-3 h-2 sm:h-3 bg-white/40 hover:bg-white/60"
                                        }`}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                    </div>
                </section>

                {/* ========== 2. Referanslarımız ========== */}
                <section className="py-6 md:py-6 bg-white relative z-0 mt-[-2rem] md:mt-[-6rem]">
                    <div className="max-w-[1728px] mx-auto px-4 md:px-margin flex flex-col items-center">
                    <p className="font-label text-sm md:text-label text-muted py-6 mb-4 md:mb-8 uppercase tracking-widest text-center font-semibold">
                        İş Ortaklarımız & Referanslarımız
                    </p>
                    <div className="flex justify-center items-center w-full">
                        <div className="marquee-container w-full overflow-hidden">
                            <div className="marquee-content flex gap-[100px] items-center">
                                {[aski, cevre, dsi, ica, iga, ilbank, kgm, toki,emlak].map((logoSrc, idx) => (
                                    <img
                                        key={idx}
                                        src={logoSrc}
                                        alt="İş Ortağı"
                                        className="h-16 md:h-20 w-auto object-contain opacity-60 grayscale hover:opacity-100 hover:grayscale-0 hover:scale-110 transition-all duration-500"
                                    />
                                ))}
                                {/* Seamless loop için kopyası */}
                                {[aski, cevre, dsi, ica, iga, ilbank, kgm, toki,emlak].map((logoSrc, idx) => (
                                    <img
                                        key={`dup-${idx}`}
                                        src={logoSrc}
                                        alt="İş Ortağı"
                                        className="h-16 md:h-20 w-auto object-contain opacity-60 grayscale hover:opacity-100 hover:grayscale-0 hover:scale-110 transition-all duration-500"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    </div>
                </section>

                {/* ========== 3. Faaliyet Alanlarımız (Hizmetler) ========== */}
                <section className="py-16 md:py-24 lg:py-[120px] bg-[#f8f9fa]">
                    <div className="max-w-[1728px] mx-auto px-4 md:px-margin">
                        <div className="text-center mb-12 md:mb-16">
                        <h2 className="font-display text-[32px] md:text-[40px] lg:text-[48px] font-bold text-[#01346b] mb-4 px-4">
                                    Geleceği İnşa Ediyoruz
                                </h2>
                                <p className="text-gray-600 max-w-2xl mx-auto px-4">
                                    Uzmanlığımızın ve tecrübemizin yanı sıra, geleceği İnşa Ediyoruz
                                </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 px-0 md:px-4 lg:px-12">
                        {/* Service 1: Üstyapı ve Konut */}
                        <div className="group relative bg-white rounded-[24px] md:rounded-[32px] p-6 md:p-10 overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col justify-between min-h-[350px] md:min-h-[400px]">
                            <div className="absolute top-0 right-0 w-64 h-64 bg-[#01346b]/5 rounded-full blur-3xl -mr-20 -mt-20 transition-transform group-hover:scale-150 duration-700"></div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 rounded-2xl bg-[#01346b]/10 flex items-center justify-center mb-8 group-hover:bg-[#01346b] transition-colors duration-500">
                                    <svg className="w-8 h-8 text-[#01346b] group-hover:text-white transition-colors duration-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                    </svg>
                                </div>
                                <h3 className="font-display text-xl md:text-2xl font-bold mb-3 md:mb-4 text-text">Üstyapı ve Konut Projeleri</h3>
                                <p className="font-body-lg text-sm md:text-base text-muted mb-6 md:mb-8">Modern, güvenilir ve estetik konut projeleri ile yeni nesil, sürdürülebilir yaşam alanları inşa ediyoruz.</p>
                                
                                <Link to="/projeler" className="inline-flex items-center justify-center gap-2 px-5 md:px-6 py-2.5 md:py-3 bg-[#01346b] text-white text-sm md:text-base font-semibold rounded-xl hover:bg-[#02457d] transition-all duration-300 shadow-md hover:shadow-lg">
                                    <span>Projeleri İncele</span>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </Link>
                            </div>
                        </div>

                        {/* Service 2: Altyapı ve Çevre */}
                        <div className="group relative bg-[#01346b] rounded-[24px] md:rounded-[32px] p-6 md:p-10 overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 flex flex-col justify-between min-h-[350px] md:min-h-[400px] transform hover:-translate-y-2">
                            <div className="absolute inset-0 bg-gradient-to-br from-[#01346b] to-[#011a38]"></div>
                            <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mb-8 group-hover:bg-white transition-colors duration-500">
                                    <svg className="w-8 h-8 text-white group-hover:text-[#01346b] transition-colors duration-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <h3 className="font-display text-xl md:text-2xl font-bold mb-3 md:mb-4 text-white">Altyapı ve Çevre Düzenleme</h3>
                                <p className="font-body-lg text-sm md:text-base text-white/80 mb-6 md:mb-8">Dayanıklı altyapı projeleri ve doğayla uyumlu çevre düzenleme uygulamalarıyla şehirlere değer katıyoruz.</p>
                                
                                <Link to="/projeler" className="inline-flex items-center justify-center gap-2 px-5 md:px-6 py-2.5 md:py-3 bg-white text-[#01346b] text-sm md:text-base font-semibold rounded-xl hover:bg-white/90 transition-all duration-300 shadow-lg hover:shadow-xl">
                                    <span>Projeleri İncele</span>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </Link>
                            </div>
                        </div>

                        {/* Service 3: Kentsel Dönüşüm */}
                        <div className="group relative bg-white rounded-[24px] md:rounded-[32px] p-6 md:p-10 overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col justify-between min-h-[350px] md:min-h-[400px]">
                            <div className="absolute top-0 right-0 w-64 h-64 bg-[#01346b]/5 rounded-full blur-3xl -mr-20 -mt-20 transition-transform group-hover:scale-150 duration-700"></div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 rounded-2xl bg-[#01346b]/10 flex items-center justify-center mb-8 group-hover:bg-[#01346b] transition-colors duration-500">
                                    <svg className="w-8 h-8 text-[#01346b] group-hover:text-white transition-colors duration-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>
                                </div>
                                <h3 className="font-display text-xl md:text-2xl font-bold mb-3 md:mb-4 text-text">Kentsel Dönüşüm & Ticari Yapılar</h3>
                                <p className="font-body-lg text-sm md:text-base text-muted mb-6 md:mb-8">Geleceğin ihtiyaçlarına uygun işlevsel ticari yapılar ve güvenli, modern kentsel dönüşüm projeleri üretiyoruz.</p>
                                
                                <Link to="/projeler" className="inline-flex items-center justify-center gap-2 px-5 md:px-6 py-2.5 md:py-3 bg-[#01346b] text-white text-sm md:text-base font-semibold rounded-xl hover:bg-[#02457d] transition-all duration-300 shadow-md hover:shadow-lg">
                                    <span>Projeleri İncele</span>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </div>
                    </div>
                </section>


                {/* ========== 4. Hakkımızda / İstatistikler ========== */}
                <section className="py-16 md:py-24 lg:py-[120px] bg-white relative overflow-hidden">
                    {/* Decorative Elements */}
                    <div className="absolute top-0 right-0 w-96 h-96 bg-[#01346b]/5 rounded-full blur-3xl"></div>
                    <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#01346b]/5 rounded-full blur-3xl"></div>

                    <div className="max-w-[1200px] mx-auto px-4 md:px-margin relative z-10">
                        <div className="text-center mb-12 md:mb-16">
                            <span className="inline-block px-6 py-2 bg-[#01346b]/10 text-[#01346b] rounded-full text-sm font-bold mb-4 tracking-wider">
                                2016'DAN BUGÜNE
                            </span>
                            <h2 className="font-display text-[32px] md:text-[40px] lg:text-[48px] font-bold text-[#01346b] mb-4">
                                Güvenilir ve Sürdürülebilir Mühendislik
                            </h2>
                            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
                                Modern teknolojiler ve yenilikçi çözümlerle geleceğin yaşam alanlarını inşa ediyoruz
                            </p>
                        </div>

                        <div className="grid md:grid-cols-2 gap-8 items-center mb-12 md:mb-16">
                            {/* Left - Content */}
                            <div className="space-y-6">
                                <div className="bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-3xl p-8 md:p-10 text-white relative overflow-hidden group">
                                    <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl group-hover:scale-150 transition-transform duration-700"></div>
                                    <div className="relative">
                                        <div className="flex items-center gap-3 mb-4">
                                            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div>
                                            <span className="text-xl font-bold">Kalite Standartları</span>
                                        </div>
                                        <p className="text-white/90 text-base leading-relaxed">
                                            Kalite, güvenlik ve sürdürülebilirlik ilkelerimizle sektörde fark yaratıyoruz. Her projemizde mükemmelliği hedefliyoruz.
                                        </p>
                                    </div>
                                </div>

                                <div className="bg-white border-2 border-gray-100 rounded-3xl p-8 md:p-10 hover:border-[#01346b]/30 hover:shadow-2xl transition-all duration-300 group">
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="w-12 h-12 bg-[#01346b]/10 rounded-xl flex items-center justify-center group-hover:bg-[#01346b] transition-colors duration-300">
                                            <svg className="w-6 h-6 text-[#01346b] group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                        </div>
                                        <span className="text-xl font-bold text-[#01346b]">İnovasyon</span>
                                    </div>
                                    <p className="text-gray-700 text-base leading-relaxed">
                                        Modern teknolojiler ve yenilikçi çözümlerle projelerimize değer katıyoruz. Geleceğin inşaat sektörünü bugünden şekillendiriyoruz.
                                    </p>
                                </div>
                            </div>

                            {/* Right - Stats Grid */}
                            <div className="grid grid-cols-2 gap-6">
                                {[
                                    { 
                                        value: "50+", 
                                        label: "Tamamlanan Proje",
                                        icon: <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />,
                                        color: "blue"
                                    },
                                    { 
                                        value: "100+", 
                                        label: "Uzman Kadro",
                                        icon: <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />,
                                        color: "emerald"
                                    },
                                    { 
                                        value: "10+", 
                                        label: "Yıllık Tecrübe",
                                        icon: <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />,
                                        color: "amber"
                                    },
                                    { 
                                        value: "%98", 
                                        label: "Müşteri Memnuniyeti",
                                        icon: <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />,
                                        color: "purple"
                                    }
                                ].map((stat, idx) => (
                                    <div key={stat.label} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 border border-gray-200 hover:border-[#01346b]/30 hover:shadow-xl transition-all duration-300 group">
                                        <div className={`w-14 h-14 bg-${stat.color}-50 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                                            <svg className={`w-7 h-7 text-${stat.color}-600`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                {stat.icon}
                                            </svg>
                                        </div>
                                        <div className="font-display text-3xl md:text-4xl font-bold text-[#01346b] mb-2">{stat.value}</div>
                                        <p className="text-gray-600 text-sm font-medium">{stat.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Bottom - Feature Cards with Gradient Icons */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {[
                                {
                                    title: "Güvenlik",
                                    desc: "İş sağlığı ve güvenliği önceliğimiz. Sıfır kaza prensibiyle çalışıyoruz.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />,
                                    gradient: "from-blue-500 to-blue-600"
                                },
                                {
                                    title: "İnovasyon",
                                    desc: "Modern teknoloji ve geleneksel yöntemlerin mükemmel harmonisi.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />,
                                    gradient: "from-emerald-500 to-emerald-600"
                                },
                                {
                                    title: "Kalite",
                                    desc: "ISO standartlarında malzeme ve detaylı kalite kontrol süreçleri.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />,
                                    gradient: "from-amber-500 to-amber-600"
                                }
                            ].map((value, idx) => (
                                <div key={value.title} className="group relative">
                                    <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white rounded-2xl transform group-hover:scale-105 transition-transform duration-300"></div>
                                    <div className="relative bg-white rounded-2xl p-6 md:p-8 border-2 border-gray-100 group-hover:border-transparent group-hover:shadow-2xl transition-all duration-300">
                                        <div className={`w-16 h-16 bg-gradient-to-br ${value.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg`}>
                                            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                {value.icon}
                                            </svg>
                                        </div>
                                        <h4 className="font-display text-xl font-bold text-gray-900 mb-3">
                                            {value.title}
                                        </h4>
                                        <p className="text-gray-600 leading-relaxed">
                                            {value.desc}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ========== 5. Çalışma Sürecimiz ========== */}
                <section className="py-16 md:py-24 lg:py-[120px] bg-[#f8f9fa]">
                    <div className="max-w-[1200px] mx-auto px-4 md:px-margin">
                        <div className="text-center mb-12 md:mb-16 px-4">
                            <h2 className="font-display text-[32px] md:text-[40px] lg:text-[48px] font-bold text-[#01346b] mb-4">
                                Çalışma Sürecimiz
                            </h2>
                            <p className="text-gray-600 max-w-2xl mx-auto">
                                Her proje, planlama aşamasından teslimata kadar titizlikle yönetilir
                            </p>
                        </div>

                        <div className="relative">
                            {/* Simple connecting line */}
                            <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#01346b]/30 to-transparent"></div>

                            {/* Timeline Steps */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
                                {approachSteps.map((step, index) => (
                                    <div
                                        key={step.title}
                                        className="relative flex flex-col items-center text-center group"
                                    >
                                        {/* Icon Circle */}
                                        <div className="relative mb-6 z-10">
                                            <div className="w-32 h-32 rounded-full bg-white border-4 border-[#01346b] flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow duration-300">
                                                <svg className="w-14 h-14 text-[#01346b]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                                    {step.icon}
                                                </svg>
                                            </div>
                                            
                                            {/* Step Number */}
                                            <div className="absolute -top-2 -right-2 w-10 h-10 bg-[#01346b] text-white rounded-full flex items-center justify-center font-bold shadow-lg">
                                                {index + 1}
                                            </div>
                                        </div>

                                        {/* Content */}
                                        <div className="px-4">
                                            <h3 className="font-display text-xl font-bold text-gray-900 mb-3 group-hover:text-[#01346b] transition-colors">
                                                {step.title}
                                            </h3>
                                            <p className="text-sm text-gray-600 leading-relaxed">
                                                {step.description}
                                            </p>
                                        </div>

                                        {/* Arrow between steps */}
                                        {index < approachSteps.length - 1 && (
                                            <div className="hidden md:block absolute -right-4 top-16 text-[#01346b]/30">
                                                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                                </svg>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    
                </section>
            </main>

            {/* ========== 7. Kurumsal Footer ========== */}
            <footer className="bg-gradient-to-b from-[#01346b] to-[#0a0a0a] text-white font-body-md w-full pt-12 md:pt-16 pb-8 md:pb-xl rounded-t-[24px] md:rounded-t-[40px] mt-section relative overflow-hidden">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
                <div className="max-w-[1728px] mx-auto w-full relative z-10 px-4 md:px-margin flex flex-col items-center">
                    
                    {/* Üst Kısım İletişim Info */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 w-full mb-12 md:mb-20 border-b border-white/10 pb-12 md:pb-16">
                        <div>
                            <h2 className="font-display text-2xl md:text-3xl font-bold mb-3 md:mb-4 text-white">BURAKYOL<span className="text-[#00a2ff]">.</span></h2>
                            <p className="text-white/60 text-sm md:text-base max-w-md font-body-md">Kaliteli malzeme, usta mühendislik ve zamanında teslimat prensibiyle Türkiye'nin her yerinde sürdürülebilir yaşam alanları inşa ediyoruz.</p>
                        </div>
                        <div className="flex flex-col md:items-end justify-center">
                            <a href="mailto:info@burakyolmuhendislik.com" className="font-display text-lg md:text-xl lg:text-3xl text-white hover:text-[#00a2ff] transition-colors break-all md:break-normal">info@burakyolmuhendislik.com</a>
                            <p className="text-white/60 mt-3 md:mt-4 text-sm md:text-base">+90 (212) 512 99 21</p>
                        </div>
                    </div>

                    {/* Footer Links */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-lg w-full mb-8 md:mb-xl text-left text-white/80 text-sm md:text-base">
                        <div className="flex flex-col gap-3 md:gap-4">
                            <h4 className="font-label text-xs md:text-sm text-white font-bold uppercase mb-1 md:mb-2 tracking-widest">Kurumsal</h4>
                            <Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link>
                            <Link to="/hakkimizda" className="hover:text-white transition-colors">Vizyon & Misyon</Link>
                        </div>
                        <div className="flex flex-col gap-3 md:gap-4">
                            <h4 className="font-label text-xs md:text-sm text-white font-bold uppercase mb-1 md:mb-2 tracking-widest">Hizmetlerimiz</h4>
                            <Link to="/hizmetler" className="hover:text-white transition-colors">Üstyapı & Konut</Link>
                            <Link to="/hizmetler" className="hover:text-white transition-colors">Altyapı Projeleri</Link>
                            <Link to="/hizmetler" className="hover:text-white transition-colors">Kentsel Dönüşüm</Link>
                        </div>
                        <div className="flex flex-col gap-3 md:gap-4">
                            <h4 className="font-label text-xs md:text-sm text-white font-bold uppercase mb-1 md:mb-2 tracking-widest">Projeler</h4>
                            <Link to="/projeler" className="hover:text-white transition-colors">Devam Eden Projeler</Link>
                            <Link to="/projeler" className="hover:text-white transition-colors">Tamamlanan Projeler</Link>
                        </div>
                        <div className="flex flex-col gap-3 md:gap-4">
                            <h4 className="font-label text-xs md:text-sm text-white font-bold uppercase mb-1 md:mb-2 tracking-widest">Adres</h4>
                            <p className="text-white/60 max-w-[200px] leading-relaxed text-sm">
                             Emirhan cad. Bayındır sok. Uygar apt. No:1/3 Beşiktaş/İstanbul
                            </p>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="flex flex-col md:flex-row items-center justify-between w-full pt-6 md:pt-8 text-white/40 text-xs md:text-sm border-t border-white/10 gap-4">
                        <p className="text-center md:text-left">© {new Date().getFullYear()} Burakyol Mühendislik. Tüm hakları saklıdır.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Home;
